<div style="margin-left: 4%; margin-right: 4%;">
  <div style="margin-top: 0.625rem;">
    <span class="chargingProjectHeader">Charging Project Setup</span>
  </div>
  <div>
    <span class="fundingProjectHeader">Select a Funding Project</span>
  </div>
  <div style="display: inline-block">
    <div style="width: 49.875rem; height: 6.25rem; background-color: #f3fafd;">
      <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem;">
        <mat-form-field class="fundingFields" [class.disabledFundingFields]="loadingStateAndBusinessUnitOptions">
          <input [(ngModel)]="fundingProjectID" 
            (ngModelChange)="clearProjectData()" (keyup.enter)="getStateAndBusinessUnitOptions()" placeholder="Funding Project ID" matInput>
        </mat-form-field>
      </div>
      <div style="margin-left: 0.3rem; display: inline-block;">
        <button (click)="getStateAndBusinessUnitOptions()" class="confirmButton" style="width: 5rem" [disabled]="!fundingProjectID" 
          [class.disabledFundingFields]="!fundingProjectID"
          [class.buttonLoading]="loadingStateAndBusinessUnitOptions">
          <span *ngIf="!loadingStateAndBusinessUnitOptions" class="buttonText" style="color: white">SUBMIT</span>
          <div *ngIf="loadingStateAndBusinessUnitOptions" class="dot-spin" style="display: inline-block; margin: auto"></div>
        </button>
      </div>
      <div style="display: inline-block; margin-left: 2.5rem;">
        <mat-form-field class="fundingFields" [class.disabledFundingFields]="!stateAndBusinessUnitLoaded">
          <mat-select [compareWith]="compareState" [(value)]="state" placeholder="State"
            (selectionChange)="stateSelected($event.value); getProjectData();">
            <mat-option *ngFor="let option of stateOptions" style="color: #696969" [value]="option"><span>{{option.state}}</span></mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="display: inline-block; margin-left: 2.5rem;">
        <mat-form-field class="fundingFields" [class.disabledFundingFields]="!stateAndBusinessUnitLoaded">
          <mat-select [(value)]="businessUnit" placeholder="Business Unit"
           (selectionChange)="filterOperatingUnitByBusinessUnit(); getProjectData()">
            <mat-option *ngFor="let option of businessUnitOptions" style="color: #696969" [value]="option"><span>{{option}}</span></mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div style="margin-left: 24rem; background: #9d1b31; color: white; height: 3.2rem; position: absolute;
    width: 50rem; visibility: hidden; z-index: 1000;" [class.showError]="errorShowing" [class.showError]="statusError">
      <div style="display: inline-block; padding-left: 0.5rem; padding-top: 0.5rem; padding-bottom: 0.5rem;">
        <img src="assets/mmaps-error.svg">
      </div>
      <div style="display: inline-block; position: absolute; left: 3.125rem; top: 0.781rem;">
        <span *ngIf="errorShowing">The entered Funding Project ID is invalid.  Please try another Funding Project ID.</span>
        <span *ngIf="statusError">The Funding Project selected in not in Open status.  Please use an Open Funding Project.</span>
      </div>
      <div style="display: inline-block; text-decoration: underline; position: absolute; right: 1.563rem; top: 0.781rem;">
        <span (click)="closeErrorMessage()" style="cursor: pointer">Ok</span>
      </div>
    </div>
  </div>
  <div [class.hideHeader]="true || !projectDataLoaded" style="display: inline-block; float: right; width: 16.066rem; margin-right: 4%;">
    <div>
      <span style="color: #696969">We found previously sent and current projects with this same information.</span>
    </div>
    <div class="removeBorder" (click)="openMatchingProjects()">
      <span style="color: #00789e;">SHOW</span>
    </div>
  </div>
  <div [class.hideHeader]="projectDataLoaded">
    <div style="border-bottom: 0.188rem solid #dddddd; margin-top: 1rem;"></div>
    <div style="width: 15.625rem; margin-top: -1rem; margin-left: 1.5rem; background: #ffffff; text-align: center;">
      <span style="font-size: 0.75rem; color: #696969;">Information below will populate automatically</span>
    </div>
  </div>
  <div [class.disabledFundingData]="!projectDataLoaded">
    <div>
      <div style="display: inline-block; margin-top: 0.563rem; margin-left: 1.95rem; pointer-events: none;">
        <mat-form-field style="width: 31.25rem; color: #696969;">
          <input [(ngModel)]="projectName" placeholder="Project Name" matInput>
        </mat-form-field>
      </div>
      <div style="display: inline-block; margin-top: 0.563rem; margin-left: 1.563rem; padding: 1rem; pointer-events: none;">
        <mat-form-field class="fundingFields">
          <mat-select [(value)]="operatingUnit" placeholder="Operating Unit">
            <mat-option *ngFor="let option of operatingUnitOptions" style="color: #696969" [value]="option"><span>{{option.OPERATING_UNIT}} - {{option.DESCR}}</span></mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="display: inline-block; margin-top: 0.563rem; margin-left: 1.563rem; pointer-events: none">
        <mat-form-field style="width: 12.5rem; color: #696969;">
          <input [(ngModel)]="projectManager" placeholder="Project Manager" matInput>
        </mat-form-field>
      </div>
    </div>
    <div style="margin-left: 1.25rem">
      <div style="font-size: 0.875rem; color: #696969; margin-bottom: 0.25rem;">Project Scope</div>
      <textarea readonly [(ngModel)]="projectLongDescription" class="longDescriptionTextBox"></textarea>
    </div>
    <div style="margin-left: 1.25rem; margin-top: 2.313rem;">
      <div style="font-size: 0.875rem; color: #696969; margin-bottom: 0.25rem;">Problem Statement</div>
      <textarea readonly [(ngModel)]="problemStatement" class="normalSizeTextBox"></textarea>
    </div>
    <div style="margin-left: 1.25rem; margin-top: 2.313rem;">
      <div style="font-size: 0.875rem; color: #696969; margin-bottom: 0.25rem;">Proposed Objective</div>
      <textarea readonly [(ngModel)]="proposedObjective" class="normalSizeTextBox"></textarea>
    </div>
    <div style="margin-left: 1.25rem; margin-top: 2.313rem;">
      <div style="font-size: 0.875rem; color: #696969; margin-bottom: 0.25rem;">Physical Address</div>
      <textarea readonly [(ngModel)]="notes" class="normalSizeTextBox"></textarea>
    </div>
    <div style="margin-bottom: 4.375rem; margin-top: 3.75rem;">
      <div class="startOverButton" (click)="startOver()"> 
        <span style="font-size: 0.875rem; color: #00789E;">START OVER</span>
      </div>
      <div style="display: inline-block">
        <div class="exitButton" (click)="exitPage()">
          <span class="exitText">EXIT</span>
        </div>
      </div>
      <div style="display: inline-block; float: right;">
        <div style="display: inline-block; margin-right: 1rem;">
          <span>This is the funding project for which I want to create a charging project:</span>
        </div>
        <div style="display: inline-block">
          <button (click)="confirmAndContinue()" class="confirmButton">
            <span class="confirmText">CONFIRM & CONTINUE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>